import { css } from '@emotion/react';

export default css({
  '&.centered-spinner': {
    width: '100%',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
});
